// src/app/DistributorMaterial.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DistributorMaterial } from  '../objects/DistributorMaterial';
import { environment } from '../environments/environment';  

@Injectable({
  providedIn: 'root',
})
export class DistributorMaterialService {
    
  private apiUrl = environment.apiUrl +'DistributorMaterials'; // Replace with your API endpoint

  constructor(private http: HttpClient) {}

  GetDistributorMaterial(): Observable<DistributorMaterial[]> {
    return this.http.get<DistributorMaterial[]>(this.apiUrl);
  }

  
  getDistributorMaterial(id:number): Observable<DistributorMaterial> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.get<DistributorMaterial>(url);
  }



  addDistributorMaterial(DistributorMaterial: DistributorMaterial): Observable<DistributorMaterial> {
    return this.http.post<DistributorMaterial>(this.apiUrl, DistributorMaterial);
  }

  editDistributorMaterial(DistributorMaterial: DistributorMaterial): Observable<DistributorMaterial> {
    const url = `${this.apiUrl}/${DistributorMaterial.id}`;
    return this.http.put<DistributorMaterial>(url, DistributorMaterial);
  }

  deleteDistributorMaterial(DistributorMaterial: DistributorMaterial): Observable<DistributorMaterial> {
    const url = `${this.apiUrl}/${DistributorMaterial.id}`;
    return this.http.delete<DistributorMaterial>(url);
  }
}
